import Vue from 'vue';
import tinymce from 'vue-tinymce-editor';
import ElementUI from 'element-ui';
import VModal from 'vue-js-modal';
import CKEditor from '@ckeditor/ckeditor5-vue';
import locale from 'element-ui/lib/locale/lang/en';
import uploader from 'vue-simple-uploader';
import VueLazyload from 'vue-lazyload';
import VueLoaders from 'vue-loaders';
import Moment from 'vue-moment';
import App from './App.vue';
import router from './Common/route/route';
import store from './Common/store/store';
import 'element-ui/lib/theme-chalk/index.css';
import Mixins from './Common/mixins';
import '../node_modules/nprogress/nprogress.css';
import 'vue-loaders/dist/vue-loaders.css';

const VueUploadComponent = require('vue-upload-component');

Vue.config.productionTip = false;

Vue.use(VueLazyload);
Vue.use(VueLoaders);
Vue.use(ElementUI, { locale });
Vue.use(uploader);
Vue.use(VModal);
Vue.use(Moment);
Vue.use(CKEditor);


Vue.component('tinymce', tinymce);
Vue.component('FileUpload', VueUploadComponent);

Vue.mixin(Mixins);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
